<div class="subContWrap">
    <!-- subTop -->
    <div class="subTop">
        <h2 class="bTit">{{ cateName }}</h2>
        <ul class="subMenu">
            <li *ngFor="let item of cates">
                <a (click)="onClickCategory(item)" [ngClass]="cate === item.cateCd ? 'on': ''">{{ item.cateName }}</a>
            </li>
        </ul>
    </div>
    <!-- //subTop -->
    <router-outlet></router-outlet>
</div>
